export default __webpack_public_path__ + "3cc14d4faad9d1011da328b37fa8803e.svg";